import React from 'react'
import { Redirect, Route, withRouter } from 'react-router-dom'
import { addLocaleData, IntlProvider } from 'react-intl'

import en from 'react-intl/locale-data/en'
import ja from 'react-intl/locale-data/ja'

import messages from '../../messages'
import AppBar from './AppBar'
import '../../App.css'
import { Background, GuestBackground, sideMenuItemStyles } from './styles'
import Navigation from './Navigation'
import { checkAdminUrl, checkJapanese, flattenMessages } from '../../lib'
import authenticate from '../authenticateHOC'

// Language dependencies
addLocaleData([...en, ...ja])

const Back = changeBackground(Background)

const Layout = ({component: Component, ...rest}) => {
  const sessionToken = sessionStorage.getItem('authToken')
  const localToken = localStorage.getItem('authToken')
  if (sessionToken === null && localToken === null) {
    return (
      <Redirect
        to={'/login'}
      />
    )
  }
  return (
    <Route
      {...rest}
      render={matchProps => (
        <IntlProvider
          locale={checkJapanese() ? 'ja' : 'en'}
          messages={flattenMessages(
            messages[checkJapanese() ? 'ja' : 'en']
          )}>
          <Back
            location={matchProps.location.pathname}
            className="min-h-inherit w-100 h-100">
            {rest.isCheckingUser ? (
              <div className="min-h-inherit w-100 flex justify-center items-center">
                Loading...
              </div>
            ) : (
              <div>
                <AppBar
                  location={matchProps.location.pathname}
                />
                <div className="min-h-inherit w-100 pt3 pr5 pl5">
                  <div className="w-100 flex">
                    <div style={{}} className="sideMenuItemStyles">
                      <Navigation {...rest} {...matchProps} />
                    </div>
                    <div style={{}} className="ml3 mainContainer">
                      <Component
                        {...matchProps}
                      />
                    </div>
                  </div>
                </div>
              </div>
            )}
          </Back>
        </IntlProvider>
      )}
    />
  )
}

export default withRouter(authenticate(Layout))

/**
 *
 *
 * @param {Object} Component
 * @returns The background as per guest or not
 */
function changeBackground (Component) {
  const BackgroundDiv = props =>
    !checkAdminUrl(props.location) ? (
      <div className="min-h-inherit">
        <GuestBackground {...props} className="absolute min-h-inherit h-100 w-100"/>
      </div>
    ) : (
      <Component {...props} />
    )
  return BackgroundDiv
}



// WEBPACK FOOTER //
// ./src/layouts/Domain/Layout.js